var _window$document;
// Used for delegating node actions when browser APIs aren't available
// like in SSR websites.
export var isDOMAvailable = typeof window !== 'undefined' && !!((_window$document = window.document) !== null && _window$document !== void 0 && _window$document.createElement);
export var canUseEventListeners = isDOMAvailable && !!(window.addEventListener || window.attachEvent);
export var canUseViewport = isDOMAvailable && !!window.screen;
export var isAsyncDebugging = false;